module.exports = __webpack_public_path__ + "static/media/Map.5749d30f.svg";